import { $httpAdmin, $httpAdminSync } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";

export interface Logo {
  id: number;
  slogo: string;
  xlogo: string;
}

export function apiLogoGet(): AxiosPromise<Logo> {
  return $httpAdmin.get('/title/mtlogoselect');
}

export async function apiLogoAdd(params: Omit<Logo, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mtlogoadd', params);
  return $httpAdmin.post('/title/mtlogoadd', params);
}

export async function apiLogoUpdate(params: Partial<Logo>): Promise<AxiosPromise> {
  await $httpAdminSync.patch('/title/mtlogonupdate', params);
  return $httpAdmin.patch('/title/mtlogonupdate', params);
}

export async function apiLogoDelete(id: Logo['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mtlogodeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mtlogodeletebyid/${id}`);
}
